import { render } from "./BroadcastMessage.vue?vue&type=template&id=7eb2e46c&scoped=true"
import script from "./BroadcastMessage.vue?vue&type=script&lang=js"
export * from "./BroadcastMessage.vue?vue&type=script&lang=js"

import "./BroadcastMessage.vue?vue&type=style&index=0&id=7eb2e46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb2e46c"]])

export default __exports__